import React from 'react';
import './RealtimeWidget.css';

const RealtimeWidget = ({ activeUsers }) => {
  const getRealtimeText = (count) => {
    if (count === 0) return "No active visitors right now";
    if (count === 1) return "1 person on your store right now";
    return `${count} people on your store right now`;
  };

  return (
    <div className="ga-realtime-wrapper">
      <div className="ga-realtime-pill">
        <div className="ga-realtime-dot-wrapper">
          <div className="ga-realtime-dot-ping"></div>
          <div className="ga-realtime-dot-core"></div>
        </div>
        <span className="ga-realtime-text">
          {getRealtimeText(activeUsers)}
        </span>
      </div>
    </div>
  );
};

export default RealtimeWidget;